import { render, staticRenderFns } from "./VolunteerScheduleManager.vue?vue&type=template&id=c363dcde&scoped=true"
import script from "./VolunteerScheduleManager.vue?vue&type=script&lang=js"
export * from "./VolunteerScheduleManager.vue?vue&type=script&lang=js"
import style0 from "./VolunteerScheduleManager.vue?vue&type=style&index=0&id=c363dcde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c363dcde",
  null
  
)

export default component.exports